import { z } from 'zod';
import { SPECIES, type ImportRow, type RowError } from './types';

export const importRowSchema = z.object({
  beanName: z.string().trim().min(1, 'Bean name is required').max(255),
  description: z.string().trim().max(1000),
  processorName: z.string().trim().max(255),
  species: z.enum(SPECIES, 'Species must be Arabica, Canephora, Liberica, or Excelsa'),
  variety: z.string().trim().max(255),
  processType: z.string().trim().min(1, 'Process type is required').max(64),
  initialQty: z.number().gte(0, 'Initial quantity must be >= 0'),
  reorderPoint: z.number().gte(0, 'Reorder warning must be >= 0'),
  standardCost: z.number().gte(0, 'Standard cost must be >= 0'),
});

export function validateRow(row: ImportRow, rowIndex: number): RowError[] {
  const result = importRowSchema.safeParse(row);
  if (result.success) return [];
  return result.error.issues.map((issue) => ({
    rowIndex,
    field: issue.path[0] as keyof ImportRow,
    message: issue.message,
  }));
}

export function validateAll(rows: ImportRow[]): RowError[] {
  return rows.flatMap((r, i) => validateRow(r, i));
}
